import { type Store } from 'vuex'
import { RootState } from '~/store/state'

export default defineNuxtRouteMiddleware(() => {
  const store = useNuxtApp().$store as Store<RootState>

  if (!store?.state?.form?.simulator?.selectedActe) {
    return '/'
  }
})
